import { useSettingsAiAgentLayout } from 'app/components/settings-ai-agent-layout/useSettingsAiAgentLayout'
import { SettingsAiAgentLayoutShadcnComponent } from 'app/components/settings-ai-agent-layout/SettingsAiAgentLayoutShadcnComponent'

export const handle = {
  title: `AI Agent`,
  breadcrumb: `AI Agent`,
}

export default function AIAgents(): React.ReactElement {
  const { children } = useSettingsAiAgentLayout()
  return <SettingsAiAgentLayoutShadcnComponent>{children}</SettingsAiAgentLayoutShadcnComponent>
}
